import { render, staticRenderFns } from "./Setting-views.vue?vue&type=template&id=c9007f6c"
import script from "./Setting-views.vue?vue&type=script&lang=js"
export * from "./Setting-views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports